export default __webpack_public_path__ + "static/media/contact.04bdbac0.jpeg";